<template>
  <div
    v-if="messages.length"
    class="boss-layout-block-large"
  >
    <accordion :is-open="true">
      <template #head>
        メッセージ履歴
      </template>
      <template #body>
        <client-job-edit-preview-message-sent :messages="messages" />
      </template>
    </accordion>
  </div>
</template>

<script>
import Accordion from '@/components/atoms/Accordion'
import ClientJobEditPreviewMessageSent from '@/components/molecules/ClientJobEditPreviewMessageSent'

export default {
  components: {
    Accordion,
    ClientJobEditPreviewMessageSent
  },
  props: {
    messages: {
      type: Array,
      default: () => []
    }
  }
}
</script>
